import React from "react";
import { Card, CardContent, Typography, Avatar, Box } from "@mui/material";

interface StatCardSummaryProps {
  type?: string;
  title: string;
  amount: number | string;
  icon: React.ElementType;
  color?: "coral" | "purple" | "green" | "primary";
  sx?: object;
  unit?: string
}

const StatCardSummary: React.FC<StatCardSummaryProps> = ({
  // type,
  title,
  amount,
  icon: IconComponent,
  color = "primary",
  sx = {},
  unit
}) => {
  const getColorStyles = (colorName: string) => {
    const colorMap: Record<string, any> = {
      coral: {
        // backgroundColor: "#ffebee",
        iconColor: "#f44336",
        titleColor: "#c62828",
      },
      purple: {
        // backgroundColor: "#f3e5f5",
        iconColor: "#9c27b0",
        titleColor: "#7b1fa2",
      },
      green: {
        // backgroundColor: "#e8f5e8",
        iconColor: "#4caf50",
        titleColor: "#2e7d32",
      },
      primary: {
        // backgroundColor: "#e3f2fd",
        iconColor: "#2196f3",
        titleColor: "#1565c0",
      },
    };
    return colorMap[colorName] || colorMap.primary;
  };

  const colorStyles = getColorStyles(color);

  return (
    <Card
      sx={{
        backgroundColor: colorStyles.backgroundColor,
        borderRadius: 3,
        boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
        border: "1px solid rgba(0,0,0,0.05)",
        transition: "transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out",
        "&:hover": {
          transform: "translateY(-2px)",
          boxShadow: "0 4px 16px rgba(0,0,0,0.15)",
        },
        ...sx,
      }}
    >
      <CardContent sx={{ p: 3 }}>
        <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
          <Avatar
            sx={{
              backgroundColor: colorStyles.iconColor,
              width: 30,
              height: 30,
              mr: 2,
            }}
          >
            <IconComponent sx={{ fontSize: 14, color: "white" }} />
          </Avatar>
          <Typography
            variant="h6"
            component="h3"
            sx={{
              color: colorStyles.titleColor,
              fontWeight: 500,
              // fontSize: "12px",
            }}
          >
            {title}
          </Typography>
        </Box>

        <Typography
          variant="h4"
          component="div"
          sx={{
            fontWeight: 700,
            color: "#2c3e50",
            mb: 0.5,
            // fontSize: { xs: "1.8rem", sm: "2.2rem" },
          }}
        >
          {amount.toLocaleString()} {unit}
        </Typography>

        {/* {type && (
          <Typography
            variant="body2"
            sx={{
              color: "#6c757d",
              fontSize: "0.875rem",
            }}
          >
            {type}
          </Typography>
        )} */}
      </CardContent>
    </Card>
  );
};

export default StatCardSummary;
